module.exports = __webpack_public_path__ + "images/emoji/ramen.a1f9d7740eaea8da0535.png";